import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Location } from '@angular/common';
import { StepperItem } from '@voyagu/portal-design-system';

import { Steps, resolveCheckoutSteps } from './stepper.util';

export { Steps } from './stepper.util';

@Component({
  selector: 'stepper',
  templateUrl: './stepper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent implements OnInit, OnChanges {
  steps: StepperItem[] = [];
  activeIndex = 0;

  @Input() step: Steps;
  @Input() isChangeMode?: boolean;
  @Input() tiers?: boolean;
  @Input() ancillaryUpsell?: boolean;
  @Input() perpetual?: boolean;
  @Input() tierChangeMode?: boolean;

  location = inject(Location);

  ngOnInit() {
    this.steps = resolveCheckoutSteps({
      ancillaryUpsell: this.ancillaryUpsell,
      tierChangeMode: this.tierChangeMode,
      isChangeMode: this.isChangeMode,
      tiers: this.tiers,
      perpetual: this.perpetual,
    }).map((label) => ({ label }));

    this.setActiveIndex();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['step'].firstChange) {
      this.setActiveIndex();
    }
  }

  setActiveIndex() {
    const index = this.steps.findIndex(({ label }) => label.toString() === this.step.toString());
    this.activeIndex = index >= 0 ? index : this.steps.length;
  }

  goBack() {
    this.location.back();
  }
}
